import GenericPopUpModal from './GenericPopUpModal'

export default GenericPopUpModal